import React from 'react';
import { useFormContext } from '../context/FormContext';

/**
 * SmartControl - Render prop component for custom form controls
 * @param {Object} props
 * @param {string} props.name - Field name
 * @param {Function} props.render - Render function ({ value, onChange, onBlur, error })
 */
export const SmartControl = ({ name, render, label }) => {
    const { formData, errors, handleFieldChange, handleFieldBlur, registerLabel, unregisterLabel } = useFormContext();

    React.useEffect(() => {
        if (label) {
            registerLabel(name, label);
        }
        return () => {
            unregisterLabel(name);
        };
    }, [name, label, registerLabel, unregisterLabel]);

    const value = formData[name];
    const error = errors[name];

    const onChange = (newValue) => {
        handleFieldChange(name, newValue);
    };

    const onBlur = () => {
        handleFieldBlur(name);
    };

    return render({
        value,
        onChange,
        onBlur,
        error,
        name
    });
};

export default SmartControl;
